import React, { useEffect, useState, useRef } from "react";
import Header from "../Components/Header";

const BestSeller = () => {
    const [allProducts, setAllProducts] = useState([]);
    const [addedProducts, setAddedProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [deletingId, setDeletingId] = useState(null);
    const [adding, setAdding] = useState(false);
    const dropdownRef = useRef(null);

    const fetchAllProducts = async () => {
        try {
            const response = await fetch('https://projects.sninfoserv.com/welb-api/admin/products/all-products/');
            const data = await response.json();
            if (data.status === "success") setAllProducts(data.data);
            else throw new Error("Failed to fetch products");
        } catch (err) {
            setError(err.message);
        }
    };

    const fetchBestSellers = async () => {
        try {
            const res = await fetch('https://projects.sninfoserv.com/welb-api/home/bestseller/');
            const data = await res.json();
            if (data.status === "success") setAddedProducts(data.data);
            else throw new Error("Failed to fetch best sellers");
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await fetchAllProducts();
            await fetchBestSellers();
            setLoading(false);
        };
        fetchData();
    }, []);

    useEffect(() => {
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const filteredProducts = allProducts.filter((p) => {
        const term = searchTerm.toLowerCase();
        return (
            p.item_name?.toLowerCase().includes(term) ||
            p.item_code?.toLowerCase().includes(term)
        );
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessMessage("");
        if (addedProducts.length >= 6) {
            setError("Maximum 4 best seller products only allowed.");
            return;
        }
        if (!selectedProduct) { setError("Please select a product"); return; }
        setAdding(true);
        try {
            const response = await fetch('https://projects.sninfoserv.com/welb-api/home/add-bestseller/', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ p_id: selectedProduct.p_id }),
            });
            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage(`"${selectedProduct.item_name}" added to Best Sellers!`);
                await fetchBestSellers();
                setSelectedProduct(null);
                setSearchTerm("");
            } else {
                throw new Error(data.message || "Product already exists in Best Sellers");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setAdding(false);
        }
    };

    const handleDelete = async (id, name) => {
        setDeletingId(id);
        setError(null);
        setSuccessMessage("");
        try {
            const response = await fetch('https://projects.sninfoserv.com/welb-api/home/delete-bestseller/', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id }),
            });
            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage(`"${name}" removed from Best Sellers.`);
                setAddedProducts((prev) => prev.filter((item) => item.id !== id));
            } else {
                throw new Error(data.message || "Failed to remove product");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setDeletingId(null);
        }
    };

    return (
        <>
            <Header />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">

                                <div className="alert alert-info">
                                    Note: The Best Seller section will be displayed on the website only when a minimum of <b>4 products</b> are added.
                                </div>

                                {successMessage && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        {successMessage}
                                        <button type="button" className="btn-close" onClick={() => setSuccessMessage("")}></button>
                                    </div>
                                )}
                                {error && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        {error}
                                        <button type="button" className="btn-close" onClick={() => setError(null)}></button>
                                    </div>
                                )}

                                <div className="mb-3">
                                    <h5
                                        className="mb-0 fw-bold d-inline-block px-3 py-2 rounded"
                                        style={{
                                            fontSize: '30px',
                                            background: "linear-gradient(135deg, #0d6efd15, #0d6efd08)",
                                            borderLeft: "5px solid #0d6efd",
                                            color: "#0d6efd",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Add Best Seller Product
                                    </h5>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-body">
                                        <div className="row align-items-end">

                                            <div className="col-md-6">
                                                <div className="mb-3" ref={dropdownRef} style={{ position: "relative" }}>
                                                    <label>Select Product</label>

                                                    <div
                                                        className="form-control d-flex justify-content-between align-items-center"
                                                        style={{ cursor: "pointer", userSelect: "none" }}
                                                        onClick={() => setDropdownOpen((v) => !v)}
                                                    >
                                                        {selectedProduct
                                                            ? <span>{selectedProduct.item_name}</span>
                                                            : <span className="text-muted">Search & select a product…</span>
                                                        }
                                                        <i className={`ti ti-chevron-${dropdownOpen ? "up" : "down"} ms-2`}></i>
                                                    </div>

                                                    {dropdownOpen && (
                                                        <div
                                                            className="card shadow"
                                                            style={{
                                                                position: "absolute",
                                                                top: "calc(100% + 4px)",
                                                                left: 0, right: 0,
                                                                zIndex: 999,
                                                                border: "1px solid #dee2e6",
                                                                borderRadius: "8px",
                                                                overflow: "hidden"
                                                            }}
                                                        >
                                                            <div className="card-body p-0">
                                                                <div className="p-2 border-bottom">
                                                                    <input
                                                                        autoFocus
                                                                        type="search"
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Type to filter by product name or code…"
                                                                        value={searchTerm}
                                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    />
                                                                </div>

                                                                <ul
                                                                    className="list-unstyled mb-0"
                                                                    style={{ maxHeight: "200px", overflowY: "auto" }}
                                                                >
                                                                    {filteredProducts.length === 0 ? (
                                                                        <li className="text-center text-muted py-3" style={{ fontSize: "0.85rem" }}>
                                                                            No products found
                                                                        </li>
                                                                    ) : (
                                                                        filteredProducts.map((p) => (
                                                                            <li
                                                                                key={p.p_id}
                                                                                className={`px-3 py-2 ${selectedProduct?.p_id === p.p_id ? "bg-light fw-semibold" : ""}`}
                                                                                style={{ cursor: "pointer", fontSize: "0.9rem" }}
                                                                                onMouseEnter={(e) => e.currentTarget.classList.add("bg-light")}
                                                                                onMouseLeave={(e) => {
                                                                                    if (selectedProduct?.p_id !== p.p_id)
                                                                                        e.currentTarget.classList.remove("bg-light");
                                                                                }}
                                                                                onClick={() => {
                                                                                    setSelectedProduct(p);
                                                                                    setSearchTerm("");
                                                                                    setDropdownOpen(false);
                                                                                }}
                                                                            >
                                                                                {selectedProduct?.p_id === p.p_id && (
                                                                                    <i className="ti ti-check me-2 text-primary"></i>
                                                                                )}
                                                                                <div>
                                                                                    {p.item_name}
                                                                                    {p.item_code && (
                                                                                        <small className="d-block text-muted">{p.item_code}</small>
                                                                                    )}
                                                                                </div>
                                                                            </li>
                                                                        ))
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="mb-3">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-light-primary text-primary font-medium w-100"
                                                        disabled={!selectedProduct || adding}
                                                    >
                                                        {adding ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                                Adding…
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ti ti-plus me-1"></i> Add
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>

                                <hr />

                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                                    <h5 className="mb-0">Best Seller Products List</h5>
                                    <span className="badge bg-dark fs-6">
                                        {addedProducts.length} {addedProducts.length === 1 ? "Product" : "Products"}
                                    </span>
                                </div>

                                <div className="table-responsive" style={{ overflowX: "auto" }}>
                                    <table className="table border table-striped table-bordered align-middle">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Product Name</th>
                                                <th>Item Code</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4">
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Loading products…
                                                    </td>
                                                </tr>
                                            ) : addedProducts.length === 0 ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center fw-bold">
                                                        No best sellers added yet.
                                                    </td>
                                                </tr>
                                            ) : (
                                                addedProducts.map((product, index) => (
                                                    <tr key={product.id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                {/* <img
                                                                    src={`https://welbeing.in/admin_panel/product_data/${product.img1}`}
                                                                    className="rounded-circle"
                                                                    width="40"
                                                                    height="40"
                                                                /> */}
                                                                <div className="ms-3">
                                                                    <h6 className="mb-0">{product.item_name}</h6>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>{product.item_code || "—"}</td>
                                                        <td className="text-center">
                                                            <div className="btn-group">
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => handleDelete(product.id, product.name)}
                                                                    disabled={deletingId === product.id}
                                                                >
                                                                    {deletingId === product.id ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                                            Removing…
                                                                        </>
                                                                    ) : (
                                                                        <i className="ti ti-trash"></i>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </>
    );
};

export default BestSeller;